import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import {
  CaretDownOutlined,
  CheckCircleFilled,
  CloudDownloadOutlined,
  EditOutlined,
  ExportOutlined,
  MailOutlined,
  UndoOutlined,
  MenuOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import { Breadcrumb, Divider, Dropdown, Menu, Button } from 'antd';
import { getTeamUrl } from 'Common'
import NotesPopover from './Components/NotesPopover'
import styles from './Component.css'

export default class _Header_ extends React.PureComponent {

  static propTypes = {
    invoice: PropTypes.object.isRequired,
    onClickActionMenuItem: PropTypes.func.isRequired,
    onChangeNotes: PropTypes.func.isRequired,
    sidebarOpen: PropTypes.bool,
    onToggleSidebar: PropTypes.func,
  }

  render () {

    const {
      invoice,
      onClickActionMenuItem,
      onChangeNotes,
      sidebarOpen,
      onToggleSidebar,
    } = this.props

    const exportMenu = (

      <Menu onClick={onClickActionMenuItem}>

        <Menu.Item key="SEND">
          <MailOutlined />
          {' Send via Email'}
        </Menu.Item>

        <Menu.Item key="DOWNLOAD">
          <CloudDownloadOutlined />
          {' Download PDF'}
        </Menu.Item>

        <Menu.Item key="EXPORT">
          <ExportOutlined />
          {' Export to Quickbooks'}
        </Menu.Item>

        <Menu.Divider />

        <Menu.Item key="EDIT">
          <EditOutlined />
          {' Edit Details'}
        </Menu.Item>

        <Menu.Divider />

        <Menu.Item key="UNDO">
          <UndoOutlined />
          {invoice.type === 'APPLICATION' ? ' Undo Application' : ' Undo Invoice'}
        </Menu.Item>

      </Menu>

    )
//        <div className={styles.header}>
    return (
      <div className={styles.wrapper}>

        <div className={styles.breadcrumbs}>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Breadcrumb separator="»">

              <Breadcrumb.Item>
                Home
              </Breadcrumb.Item>

              <Breadcrumb.Item>
                <NavLink to={getTeamUrl("invoices")}>
                  Invoices
                </NavLink>
              </Breadcrumb.Item>

              <Breadcrumb.Item>
                {invoice.reference}
              </Breadcrumb.Item>

            </Breadcrumb>

            {onToggleSidebar && (
              <button
                onClick={onToggleSidebar}
                style={{
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '4px 8px',
                  fontSize: '20px',
                  color: '#1890ff',
                  display: 'none',
                }}
                className="mobile-sidebar-toggle-btn"
                aria-label="Toggle sidebar"
              >
                {sidebarOpen ? <CloseOutlined /> : <MenuOutlined />}
              </button>
            )}
          </div>

          <style>{`
            @media (max-width: 768px) {
              .mobile-sidebar-toggle-btn {
                display: inline-block !important;
              }
            }
          `}</style>

        </div>

        <Divider />

        <div className="_header_bar">

            <div className={styles.title}>
            {invoice.title}
          </div>

          {!!invoice.added_to_quickbooks && (
            <div className={styles.addedToQuickbooks}>
              <CheckCircleFilled className={styles.addedToQuickbooksIcon} />
              {' Added to Quickbooks'}
            </div>
          )}

          <NotesPopover
            notes={invoice.notes}
            onChangeNotes={onChangeNotes}
          />

          <div style={{ width: 16 }} />

          <Dropdown overlay={exportMenu} trigger={['click']}>
            <Button type="primary">
              {'Actions '}
              <CaretDownOutlined />
            </Button>
          </Dropdown>

        </div>

      </div>
    );
  }
}
